import { createActionHelpers } from 'vuex-loading';
import { findLast } from 'lodash';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    outletList: [],
    lastQuery: null,
    outlet: {
        id: null,
        media_urls: [],
        centrals: [],
        pricebook: [],
        latitude: null,
        longitude: null,
        taxes: [],
        location: '',
        name: '',
        code: null,
        address: '',
        district: '',
        state: '',
        signage: '',
        regions: [],
        cost_center_station: '',
        cost_center_c_store: '',
        sap_id: '',
        fullname: '',
        email: '',
        roles: [],
        preference: {
            currency: null,
            timezone: null,
            phone: null,
            operation_hours: [],
        },
        metas: [],
    },
};

const getters = {
    outletList: state => {
        return state.outletList;
    },
    outlet: state => state.outlet,
    outletImage: state => {
        if (!state.outlet.media_urls.length) {
            return '/img/slurp-500.png';
        }

        return findLast(state.outlet.media_urls.s512);
    },
};

const mutations = {
    setOutlet(state, outlet) {
        state.outlet = outlet;
    },

    setOutletList(state, data) {
        state.outletList = data;
    },

    setOutletTaxes(state, taxes) {
        state.outlet.taxes = taxes;
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },

    addOutlet(state, outlet) {
        state.outletList.push(outlet);
    },
};

const actions = {
    findOutlets({ commit, dispatch }, params) {
        let options = {
            params: params,
        };

        let outlets = state.outletList.filter(o => {
            return params.ids.includes(o.id);
        });

        if (outlets.length === params.ids.length) {
            return Promise.resolve(outlets);
        }

        startLoading(dispatch, 'find-outlets');

        return axios
            .get(Laroute.route('franchise.vue.outlets'), options)
            .then(res => {
                endLoading(dispatch, 'find-outlets');
                return res.data.data;
            })
            .catch(err => {
                endLoading(dispatch, 'find-outlets');
                throw err;
            });
    },

    getOutletListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.outletList.length || state.lastQuery != params.query) {
            return dispatch('getOutletList', params);
        }

        return Promise.resolve(state.outletList);
    },

    getOutletList({ commit, dispatch }, params) {
        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-outlet');

        return axios
            .get(Laroute.route('franchise.vue.outlets'), options)
            .then(res => {
                let data = res.data.data;

                commit('setOutletList', data);
                commit('setLastQuery', options.params.query);
                endLoading(dispatch, 'fetch-outlet');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-outlet');
                throw err;
            });
    },

    async getOutlet({ dispatch, commit }, id) {
        startLoading(dispatch, 'fetch-outlet');
        const url = Laroute.route('franchise.outlet.show', { id });

        try {
            const { data } = await axios.get(url);
            commit('setOutlet', data);
            endLoading(dispatch, 'fetch-outlet');

            return data;
        } catch (e) {
            endLoading(dispatch, 'fetch-outlet');
            throw e;
        }
    },

    updateOutlet({ commit, dispatch }, outlet) {
        let route = Laroute.route('franchise.outlet.update', {
            id: outlet.outlet.id,
        });
        startLoading(dispatch, 'save-outlet');

        return axios
            .patch(route, outlet)
            .then(res => {
                endLoading(dispatch, 'save-outlet');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-outlet');
                throw err;
            });
    },

    createOutlet({ commit, dispatch }, outlet) {
        let route = Laroute.route('franchise.outlet.store');
        startLoading(dispatch, 'save-outlet');

        return axios
            .post(route, outlet)
            .then(res => {
                commit('addOutlet', res.data);
                endLoading(dispatch, 'save-outlet');

                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-outlet');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/outlet.js